import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DataMartApiConfiguration implements IDataMartApiConfiguration {
  rootUrl!: string;
  graphQlUrl!: string;
  crudUrl!: string;
}

export interface IDataMartApiConfiguration {
  rootUrl: string;
  graphQlUrl: string;
  crudUrl: string;
}
